/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_New_VersionInputs */

const es_pwa_new_version = /** @type {(inputs: Pwa_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay una nueva versión disponible`)
};

const en_pwa_new_version = /** @type {(inputs: Pwa_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new version is available`)
};

/**
* | output |
* | --- |
* | "A new version is available" |
*
* @param {Pwa_New_VersionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const pwa_new_version = /** @type {((inputs?: Pwa_New_VersionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_New_VersionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pwa_new_version(inputs)
	return en_pwa_new_version(inputs)
});
export { pwa_new_version as "pwa.new_version" }